import { GET_DMX_PROFILE_BY_ID, GET_DMX_PROFILE_BY_ID_SUCCESS, GET_DMX_PROFILE_BY_ID_ERROR } from './actionTypes';

const initialState = {
  errorGetDmxProfileById: '',
  loadingGetDmxProfileById: false,
  profile: null,
};

const getProfileById = (state = initialState, action) => {
  switch (action.type) {
    case GET_DMX_PROFILE_BY_ID:
      state = { ...state, loadingGetDmxProfileById: true };
      break;
    case GET_DMX_PROFILE_BY_ID_SUCCESS:
      state = { ...state, loadingGetDmxProfileById: false, profile: action.payload.profile };
      break;
    case GET_DMX_PROFILE_BY_ID_ERROR:
      state = { ...state, errorGetDmxProfileById: action.payload, loadingGetDmxProfileById: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getProfileById;
